module.exports = __webpack_public_path__ + "static/CEOToday-da55f28458910a9a9e501722dd818dbd.png";